import { Language, EditionType } from '@graphics/gfx-common/dist/constants'
import { IInitAction } from './init'
import { ITypeaheadObject } from './pack'

// Action types
export enum types {
  GET_PUBLISHED_GRAPHIC_BY_ID__STARTED = 'GET_PUBLISHED_GRAPHIC_BY_ID__STARTED',
  GET_PUBLISHED_GRAPHIC_BY_ID__SUCCESS = 'GET_PUBLISHED_GRAPHIC_BY_ID__SUCCESS',
  GET_PUBLISHED_GRAPHIC_BY_ID__FAILURE = 'GET_PUBLISHED_GRAPHIC_BY_ID__FAILURE',
}

export interface IGetPublishedGraphicAction {
  type: types.GET_PUBLISHED_GRAPHIC_BY_ID__STARTED
  id: string
}

export interface IGetPublishedGraphicSuccessAction {
  type: types.GET_PUBLISHED_GRAPHIC_BY_ID__SUCCESS
  publishedGraphicData: IPublishedGraphic
}

export interface IFailureAction {
  type: types.GET_PUBLISHED_GRAPHIC_BY_ID__FAILURE
  message: string
}

export type PublishedGraphicActionsType =
  | IGetPublishedGraphicAction
  | IGetPublishedGraphicSuccessAction
  | IFailureAction
  | IInitAction

export interface IPublishedGraphicBasic {
  isLoading?: boolean
  group: string
  id: string
  internalId: string
  internalPackId: string
  title: string
  slugline: string
  description: string
  byline: string
  topicCodes: ITypeaheadObject[]
  width?: number
  height?: number
  previewImageURI?: string
  publishedDate: string
  shortURI: string
  thumbnailURI: string
  graphicType: EditionType | ''
  graphicSubType: string | null
  mediaType?: string
}

export interface IPublishedGraphic extends IPublishedGraphicBasic {
  groupTitle?: string
  language: Language | null
  location: ITypeaheadObject
  mimeType?: string
  publishing: IGraphicPublishing
  dataStreamGraphic?: {
    dataStreamURI: string
  }
  dataStreamData?: {
    fileName: string
    requests: object[]
  }
  lastPublishedDate: string
  modified?: string
}

export interface IGraphicPublishing {
  locations: Array<
    IPublishedGraphicBaseLocationAWS | IPublishedGraphicBaseLocationMedia
  >
}

export interface IPublishingLocation {
  access: string
  firstPublished: string
  hosted: boolean
  name: string
  previewImageURI: string
  publishedDate: string
  publishedURI: string
  revision: number
  shortURI: string
  thumbnailURI: string
  title: string
}

export interface IPublishedGraphicBaseLocation {
  name: string
  title: string
  hosted: boolean
  access: string
  firstPublished: string
  publishedDate: string
}

export interface IPublishedGraphicBaseLocationAWS
  extends IPublishedGraphicBaseLocation {
  previewImageURI: string
  publishedURI: string
  revision: number
  shortURI: string
  thumbnailURI: string
}

export interface IPublishedGraphicBaseLocationMedia
  extends IPublishedGraphicBaseLocation {
  destinations: string[]
  iid: string
  urn: string
  fileUrn: string
}
